var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 51.5,
    cy: 51.5,
    r: 51.5,
    fill: "#283EB4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.25 43.2499L49.5 49.4999M43.25 43.2499L46.1667 40.3332V39.9165L43.7667 38.9165C42.0417 38.1977 40.426 37.2406 38.9667 36.0732L37 34.4999H36.5833L34.5 36.5832V36.9999L36.0733 38.9665C37.2407 40.4259 38.1978 42.0416 38.9167 43.7665L39.9167 46.1665H40.3333L43.25 43.2499ZM54.89 60.3332C57.5046 63.3004 60.0151 66.3578 62.4167 69.4999H62.8333L69.5 62.8332V62.4165C69.5 62.4165 65.3833 59.3299 60.3333 54.8899M61.1667 51.1665C62.5506 51.1669 63.9128 50.8227 65.1303 50.1648C66.3479 49.507 67.3824 48.5563 68.1406 47.3986C68.8987 46.2408 69.3566 44.9125 69.4729 43.5335C69.5892 42.1545 69.3602 40.7682 68.8067 39.4999H67.8333L62.8333 44.4999H59.5V41.1665L64.5 36.1665V35.1932C63.0062 34.5401 61.3536 34.3395 59.7469 34.6164C58.1402 34.8932 56.65 35.6352 55.4608 36.7506C54.2717 37.8659 53.4358 39.3056 53.0568 40.8913C52.6777 42.4769 52.7721 44.139 53.3283 45.6715L50.3333 48.6665C42.8333 56.1665 34.5 62.4165 34.5 62.4165V62.8332L41.1667 69.4999H41.5833C41.5833 69.4999 47.8333 61.1665 55.3333 53.6665L58.3283 50.6715C59.2384 51.0005 60.199 51.168 61.1667 51.1665Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipment);
export default __webpack_public_path__ + "static/media/equipment.bac530dde87ba5521ee362999f1f6382.svg";
export { ForwardRef as ReactComponent };